import { isJSON } from './common'
import { doPost, doPost2 } from './common'
//This has gotta get cleaned up re: promise rejects at some point. MY BAD FAM
/*
example payload
42.374063, -71.043045
/location/locate 
{
    "client": "gdsfghdfh",
    "latitude": 40.65262,
    "longitude": -111.90988, 
    "distance": 10
}
*/

const getLocationInfoFromZip = async params => {
  try {
    const response = await doPost2(`/location/locate`, params)

    return response.text().then(data => {
      if (response.status !== 200) {
        return new Promise((resolve, reject) => {
          reject({
            status: response.status,
            success: response.ok,
            detail: isJSON(data) ? JSON.parse(data) : data,
          })
        })
      } else {
        return {
          status: response.status,
          success: response.ok,
          detail: isJSON(data) ? JSON.parse(data) : data,
        }
      }
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

const getLocationInfoFromCoordinates = async params => {
  try {
    const response = await doPost2(`/location/locateByLatLong`, params)

    return response.text().then(data => {
      if (response.status !== 200) {
        return new Promise((resolve, reject) => {
          reject({
            status: response.status,
            success: response.ok,
            detail: isJSON(data) ? JSON.parse(data) : data,
          })
        })
      } else {
        return {
          status: response.status,
          success: response.ok,
          detail: isJSON(data) ? JSON.parse(data) : data,
        }
      }
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

const getZipFromCoordinates = coordinates => {
  try {
    let url = new URL(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.latitude},${coordinates.longitude}&key=${process.env.GOOGLE_MAPS_API_KEY}`,
    )

    return fetch(url, {
      method: 'GET',
    }).then(response => {
      return response.text().then(data => {
        if (response.status !== 200) {
          throw new Error(response.status)
        } else {
          return {
            status: response.status,
            success: response.ok,
            detail: isJSON(data) ? JSON.parse(data) : data,
          }
        }
      })
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      reject({
        success: false,
        message: `Problem getting zip code coordinates: Message: ${e}`,
      })
    })
  }
}

/*
{
   "error_message" : "API keys with referer restrictions cannot be used with this API.",
   "results" : [],
   "status" : "REQUEST_DENIED"
}

*/

const getCoordinatesFromZip = async zip => {
  let theurl = new URL(
    `https://maps.googleapis.com/maps/api/geocode/json?&address=${zip}&key=${process.env.GOOGLE_MAPS_API_KEY}`,
  )

  let respBody = await fetch(theurl, {
    method: 'GET',
  }).then(response => {
    return response.text().then(data => {
      if (isJSON(data)) {
        return JSON.parse(data)
      } else {
        return data
      }
    })
  })

  if (respBody.error_message) {
    throw new Error(respBody.error_message)
  } else {
    return respBody.results[0].geometry.location
  }
}

const start = (breakId, stepId) => {
  // console.log(breakId)

  let payload = {
    breakId: breakId,
    stepId: stepId,
    stepType: 'lead',
  }

  return doPost(`/location/start`, payload)
}

const complete = (breakId, stepId, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    skipped: stepSkipped,
  }

  return doPost(`/location/complete`, payload)
}

const awardPoints = (breakId, stepId, nonce) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    nonce: nonce,
  }

  return doPost(`/location/awardPoints`, payload)
}
export {
  getCoordinatesFromZip,
  getZipFromCoordinates,
  getLocationInfoFromZip,
  getLocationInfoFromCoordinates,
  start,
  complete,
  awardPoints,
}
